
// Vue
import { Component, Vue, Prop } from "vue-property-decorator";

// Vuex
import { Getter } from "vuex-class";

// Utils
import { DeviceService } from "@sureview/v2-cameras";

// Types
import OutputAction from "@/constants/OutputAction";

// Services
import api from '@/services/api.service';
import { processLoggingPostDoorAction } from "@/services/postDoorActionLogging.service";

@Component
export default class ManualLockUnlock extends Vue {
    @Prop({ default: false, type: Boolean }) disabled!: boolean;
    @Prop({ default: "", type: String }) reason!: string;
    @Prop({ default: 0, type: Number }) deviceId!: number;
    @Prop({ default: 0, type: Number }) deviceServerTypeId!: number;
    @Prop({ default: "", type: String }) regionUrl!: string;

    @Getter getFeature: (features: string[]) => boolean;

    private changingState: boolean = false;
    private outputActionState: OutputAction = OutputAction.Off;

    private outputAction: typeof OutputAction = OutputAction;

    private eventId: number = 0;

    private get postDoorActionLoggingEnabled(): boolean {
        return this.getFeature(["Alarms", "QuickControl", "LogDoorAction"]);
    }

    /**
     * @summary method to handle toggling the state of the door lock / unlock
     */
    private async toggleRelayState(outputAction: OutputAction): Promise<void> {
        this.changingState = true;
        this.outputActionState = outputAction;

        try {
            await this.sendCmd(outputAction);

            if (this.postDoorActionLoggingEnabled) {
                processLoggingPostDoorAction(
                    outputAction,
                    this.deviceId,
                    this.deviceServerTypeId
                );
            }
        } catch(ex) {
            this.changingState = false;
            this.$notify({
                type: "error",
                title: "Quick Control",
                text: ex
                    ? ex.statusText
                    : `Unable to ${ outputAction == OutputAction.Off ? 'Unlock': 'Reset' } the relay - please contact support if this problem persists.`
            });

            return;
        } finally {
            this.changingState = false;
        }
    }

    /**
     * @summary method to handle communication to the device service
     */
    private async sendCmd(outputAction: OutputAction): Promise<void> {
        // Get the details reqd to trigger the relay, and attach the note
        const { data } = await api.deviceQuickControl(this.deviceId,
            this.reason, this.eventId, this.regionUrl);

        this.eventId = data.eventId;
        const device = data.device;

        const deviceService = new DeviceService(device.deviceServerEndpoint ?? '');

        // Pulse the relay
        await deviceService.sendOutputCmd(
            device.deviceServiceSession,
            device.deviceID,
            null, // outputType does not exist in device model so pass null at the moment
            outputAction,
        );
    }
}
